module.exports = __webpack_public_path__ + "static/media/tick-hexagon-plain.ca6fb44c.svg";